/*!
 * jQuery validations extensions for Diligentia OV validation
 *
 * MUST be loaded after jQuery validate-ov
 *
 * Version: 0.1
 */
(function (factory) {
    /*
     * if ( typeof define === "function" && define.amd ) { define( ["jquery",
     * "./jquery.validate"], factory ); } else if (typeof module === "object" &&
     * module.exports) { module.exports = factory( require( "jquery" ) ); } else {
     */
    factory(jQuery);
    /*
     * }
     */
}(function (jQuery) {

    // Custom validations

    jQuery.validator.addMethod("ovTipoContratacion", function (value, element, arg) {
        return value !== '-1' && value !== '';
        //return value !== ' ';

    }, "Please select a type");

    // Validar teléfono de 9 dígitos si es español o hasta 20 si es extranjero
    jQuery.validator.addMethod("ovPhone", function (value, element) {
        if (!value || !value.toString().trim()) {
            // Empty or prefix without a number
            return "dependency-mismatch";
        }

        var intlPhone = window.intlTelInputGlobals.getInstance(element);
        var validatedPhone = validatePhone(intlPhone.selectedCountryData.dialCode, value, false);

        if (validatedPhone && element.value.includes(" ")) {
            element.value = element.value.replaceAll(" ", "");
        }

        return validatedPhone;
    }, "Please specify a valid phone number");

    jQuery.validator.addMethod("ovIdentityDocument", function (value, element) {
        return validationsUtil.validateDocument(value) || validationsUtil.validatePassport(value);
    }, "Please specify a valid identity document");

    // Validar teléfono de 9 dígitos empezando por 6 o 7 si es español o hasta 20 si es extranjero
    jQuery.validator.addMethod("ovMobile", function (value, element) {
        if (!value || !value.toString().trim()) {
            // Empty or prefix without a number
            return "dependency-mismatch";
        }

        var intlPhone = window.intlTelInputGlobals.getInstance(element);
        var validatedPhone = validatePhone(intlPhone.selectedCountryData.dialCode, value, true);

        if (validatedPhone && element.value.includes(" ")) {
            element.value = element.value.replaceAll(" ", "");
        }

        return validatedPhone;
    }, "Please specify a valid mobile phone number starting with numbers 6 or 7");

    /**
     * Complete jquery-validate extra IBAN validation with the specific spanish bank account validation
     */

    let isIbanValid = true;
    jQuery.validator.addMethod("ovIban", function (value, element) {
        isValidIBANNumber(value).then(isValid => isIbanValid = isValid);

        return value.length && isIbanValid;
    }, 'Please specify a valid IBAN');

    /*
 * Returns true if the IBAN is valid
 * Returns false according to validations in 'ibantools' npm package (see ui-widgets)
 */
    function isValidIBANNumber(input) {
        return new Promise(function (resolve, reject) {
            Liferay.Loader.require(['cxov-ui-widgets@1.0.0'], function (uiWidgets) {
                if (uiWidgets) {
                    resolve(uiWidgets.validateIban(input));
                } else {
                    console.error('Could not load cxov-ui-widgets');
                    reject(false);
                }
            });
        });
    }

    function mod97(string) {
        var checksum = string.slice(0, 2), fragment;
        for (var offset = 2; offset < string.length; offset += 7) {
            fragment = String(checksum) + string.substring(offset, offset + 7);
            checksum = parseInt(fragment, 10) % 97;
        }
        return checksum;
    }

    var validatePhone = function (dialCode, phone, isMobile) {
        // Validate as number before converting to string for digit count
        var number = parseInt(phone.toString().trim().replaceAll(" ", ""));

        if (!number || isNaN(number)) {
            return false;
        }

        var numberStr = number.toString();

        if (dialCode === "34") {
            return numberStr.length === 9
                && (!isMobile || (numberStr[0] === "6" || numberStr[0] === "7"));
        } else {
            return numberStr.length <= 20 && numberStr.length >= 9;
        }
    }

    var oldAcceptValidator = $.validator.methods["accept"];

    $.validator.addMethod("oldAccept", function (value, element, param) {
        return oldAcceptValidator(value, element, param);
    });

    var validateFileAccept = function (file, accept) {
        if (["function", "object"].includes(typeof AcValidations) && AcValidations.validateFileAccept) {
            return AcValidations.validateFileAccept(file, accept);
        } else if (!file || typeof accept !== "string" || accept.length === 0) {
            return true;
        } else {
            var fileExt = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
            var fileType = file.type.toLowerCase();
            var accepts = accept.toLowerCase().trim().split(",");

            for (var index = 0; index < accepts.length; index++) {
                var accept = accepts[index];
                var checkTypeStarts = false;

                if (accept.length === 0) {
                    continue;
                }

                if (accept.endsWith("*")) {
                    checkTypeStarts = true;
                    accept = accept.substring(0, accept.length - 1);
                }

                if (fileExt === accept
                    || (!checkTypeStarts && fileType === accept)
                    || (checkTypeStarts && fileType.startsWith(accept))) {
                    return true;
                }
            }

            return false;
        }
    }

    /**
     * Accept a value from a file input based on a required mimetype or a filename extension.
     *
     * Fix jquery-validate "accept" attribute validation to support simple filename extensions.
     *
     * Fixes => https://github.com/jquery-validation/jquery-validation/issues/2388
     * DOC => https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/file
     */
    $.validator.addMethod("accept", function (value, element, param) {

        // Split mime on commas in case we have multiple types we can accept
        var accept = typeof param === "string" ? param.replace(/\s/g, "") : "";
        var optionalValue = this.optional(element);

        // Element is optional or typeParam is empty
        if (optionalValue) {
            return optionalValue;
        }

        if (accept === "") {
            return true;
        }

        if ($(element).attr("type") === "file") {
            // Check if the element has a FileList before checking each file
            if (element.files && element.files.length) {
                for (var i = 0; i < element.files.length; i++) {
                    if (!validateFileAccept(element.files[i], accept)) {
                        return false;
                    }
                }
            }
        }

        // Either return true because we've validated each file, or because the
        // browser does not support element.files and the FileList feature
        return true;
    }, $.validator.format("Please enter a value with a valid mimetype."));
}));
